import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import DiseaseDetails from './components/DiseaseDetails';
import Home from './components/Home';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:disease/:section" element={<DiseaseDetails />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
